import NoImage from "../../assets/images/No_Image_Available.jpg";
import { MdOutlineDirectionsWalk } from "react-icons/md";
import { WiDayCloudy } from "react-icons/wi";
import { GiStrong } from "react-icons/gi";
import { BsCloudMoonFill } from "react-icons/bs";
import LazyImage from "../image/LazyLoadImage";


const EventComponent = ({ adventure, imageHeigth }) => {
  return (
    <div className="w-full relative h-full cursor-pointer">
      <div
      >
        <LazyImage
          src={adventure?.displayImage ?? NoImage}
          className={`w-full ${
            imageHeigth === undefined ? "h-[280px]" : "h-[150px]"
          } object-cover rounded-lg shadow-md`}
        />
        {/* <img
          src={adventure?.displayImage ?? NoImage}
          alt="event"
          className="w-full h-full object-cover rounded-lg shadow-md"
        /> */}
      </div>

      <div className="px-3 my-3">
        <div className="font-bold">{adventure?.name}</div>

        <div className="text-[1.2rem] py-1 max-w-[250px]">
          {adventure?.description?.split(" ").slice(0, 10).join(" ") + "..."}
        </div>
        <div className="text-[1.5rem] font-bold">{adventure?.startDate}</div>
      </div>

      <div className="px-3 flex space-x-5 relative bottom-0">
        {/* <div
          className={`flex space-x-2 items-center border-[1px] ${
            adventure?.type === "1"
              ? "border-orange-500"
              : "border-color-primary"
          } px-3 rounded-md`}
        >
          <div>
            {adventure?.type === "1" ? (
              <WiDayCloudy color="orange" />
            ) : (
              <BsCloudMoonFill color="darkblue" />
            )}
          </div>
          <div className="uppercase text-sm font-bold ">
            {adventure?.typeLabel}
          </div>
        </div> */}
        <div
          className={`${
            adventure?.difficulty === "1"
              ? "bg-green-800"
              : adventure?.difficulty === "2"
              ? "bg-gray-500"
              : adventure?.difficulty === "3"
              ? "bg-orange-600"
              : "bg-red-600"
          } px-5 rounded-md flex space-x-2 items-center `}
        >
          <div>
            <GiStrong color="white" />
          </div>
          <div className="uppercase text-sm font-bold text-color-white">
            {adventure?.difficultyLabel}
          </div>
        </div>
        <div
          className={`bg-blue-800 px-5 py-2 rounded-md flex space-x-2 items-center `}
        >
          <div>
            <MdOutlineDirectionsWalk color="white" />
          </div>
          <div className="uppercase text-sm font-bold text-color-white">
            {adventure?.distanceInKm} KM
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventComponent;
